<template>
  <div class="mobileTopNav">
    <div class="Nav-title" @click="getHome">{{ $t('title') }}</div>
    <div class="search-box">
      <input
        type="text"
        :placeholder="$t('home.placeholder')"
        v-model="searchText"
        @keydown.enter="goSearch()"
        @focus="handlefocus"
        class="search_input"
      />
      <div class="search-btn" @click="goSearch">
        <!-- {{ $t('home.search') }} -->
        <!-- <svg-icon className="search" /> -->
        <svg-icon
          icon-class="search"
          className="search"
          customStyle="fill: #ccc;font-weight: 700;"
        />
        <!--  -->
      </div>
    </div>
    <div class="right">
      <div class="Ranking" @click="setLang">
        <div class="textbox">{{ $t('home.lang') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getToken, getSession, removeToken, removeSession } from '@/utils/auth';
import { getUserInfo } from '@/request/api/login/login';
export default {
  name: 'TopNav',
  props: '',
  data() {
    return {
      userName: 'user',
      Login: false,
      topLeft: [
        {
          ge: true,
          icon: true,
          text: '手机版',
        },
        {
          ge: false,
          icon: false,
          text: '商家入驻',
        },
      ],
      topRight: [
        {
          ge: true,
          icon: true,
          text: '切换买家',
        },
        {
          ge: true,
          icon: true,
          text: '咚咚',
        },
        {
          ge: true,
          icon: false,
          text: '商家后台',
        },
        {
          ge: true,
          icon: false,
          text: '客户服务',
        },
        {
          ge: true,
          icon: false,
          text: '网站导航',
        },
      ],
      searchText: '',
    };
  },
  components: {},
  created() {
    console.log('不懂吗');
    this.Islogin();
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.getgoods();
      }, 200);
    });
  },
  methods: {
    handlefocus() {},
    getgoods() {
      // console.log('sss', this.$route.query);
      this.searchText = this.$route.query.keyword;
    },
    getHome() {
      if (this.$route.path != '/') {
        this.$router.push('/');
      }
    },
    goSearch() {
      // if (this.$route.path != '/search') {
      //   // this.$router.push('/search');
      //   this.$router.push({
      //     path: '/search',
      //     query: {
      //       keyword: this.searchText,
      //     },
      //   });
      // }
      this.$router.push({
        path: '/search',
        query: {
          keyword: this.searchText,
        },
      });
      setTimeout(() => {
        location.reload();
      }, 200);
    },
    setLang() {
      if (!localStorage.getItem('lang')) {
        localStorage.setItem('lang', 'en_US');
        location.reload();
        return;
      }
      var langs = localStorage.getItem('lang');
      if (langs == 'en_US') {
        localStorage.setItem('lang', 'zh_CN');
        location.reload(); //重新加载
      } else if (langs == 'zh_CN') {
        localStorage.setItem('lang', 'en_US');
        location.reload();
      }
    },
    Islogin() {
      // var tokedata = {
      //   Authorization: getToken(),
      //   updateSession: getSession(),
      // };
      getUserInfo().then((res) => {
        var data = res.data;
        console.log(data);
        if (data.code == 0) {
          this.Login = true;
          this.userName = data.data.user.username;
          console.log(data.data.user.username);
        } else {
          this.Login = false;
        }
      });
    },
    getregister() {
      if (!this.Login) {
        if (this.$route.path != '/register') {
          this.$router.push('/register');
        }
      } else {
      }
    },
    getLogin() {
      if (!this.Login) {
        if (this.$route.path != '/login') {
          this.$router.push('/login');
        }
      } else {
        this.Login = false;
        removeToken();
        removeSession();
        this.$toast.success('Successful exit!', {
          position: 'top-right',
          timeout: 3000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          closeButton: 'button',
          icon: true,
          rtl: false,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.mobileTopNav {
  // background: #fff;
  // background: rgb(249, 249, 249);
  background: #f60;
  padding: 1vh 0px;

  font-size: 16px;
  display: flex;
  align-items: center;
  .Nav-title {
    padding: 1vw 0.5vh;
    font-size: 4vw;
    color: #fff;
    font-weight: 700;
  }
  .search-box {
    width: 65%;
    display: flex;
    justify-content: center;
    height: 100%;
    .search_input {
      height: 4vh;
      width: 70%;
      border-radius: 4px 0px 0px 4px;
      border: none;
      outline: none;
      padding: 0px 4px;
    }
    .search-btn {
      border-radius: 4px;
      height: 4vh;
      background-color: #fff;
      border-radius: 0px 4px 4px 0px;
      display: flex;
      align-items: center;
      padding: 0px 6px;
    }
  }
  .right {
    display: flex;
    align-items: center;
    color: #fff;
  }
}
</style>
